
export default {

  //labs
  getCountries() {
    return env.API.get('/misc/countries');
  },
  getCurrencies() {
    return env.API.get('/currencies');
  },
  tillage() {
    return env.API.get('/misc/tillageValues');
  },
  getPlans() {
    return env.API.get('/misc/plans');
  },
  getLanguages() {
    return env.API.get('/misc/languages');
  },
  getVersion() {
    return env.API.get('/version');
  },


}
